<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils :title="title"/>
            <breadcrumb :items="[{label: title, path: $router.currentRoute.path}]"/>

            <ibox>
                <template v-slot:title v-if="!$appUtils.isMobile()">
                    <h5><svg-icon icon="file-pdf"/>{{title}}</h5>
                </template>
                <template v-slot:content>
                    <div class="t-c" v-if="$appUtils.isDesktop()" v-show="!loading">
                        <span class="btn-group btn-group-sm">
                            <a href="javascript:history.go(-1)"
                               v-if="!$appUtils.isMobile()"
                               class="btn btn-sm btn-secondary"
                            ><svg-icon icon="arrow-left"/> Voltar</a>
                            <button type="button"
                                    title="Abrir em outra página"
                                    class="btn btn-sm btn-info"
                                    @click="open"
                            ><svg-icon icon="external-link-alt"/> Abrir</button>
                            <button type="button"
                                    title="Imprimir"
                                    class="btn btn-sm btn-primary"
                                    @click="print"
                            ><svg-icon :class="{'refresh rotate-1-seg': downloading}" :icon="downloading ? 'sync' : 'print'"/> Imprimir</button>
                            <button type="button"
                                    title="Download"
                                    class="btn btn-sm btn-primary"
                                    :class="{'btn-dark': !$appUtils.isMobile()}"
                                    @click="downloadPdf()"
                            ><svg-icon :class="{'refresh rotate-1-seg': downloading}" :icon="downloading ? 'sync' : 'cloud-download-alt'"/> Download</button>
                        </span>
                    </div>

                    <div class="container-canvas"
                         id="pdfContainer"
                         ref="pdfContainer"></div>
                    <div v-if="loading" class="loading-container">
                        <svg-icon icon="sync" svg-class="refresh rotate-1-seg"/>
                    </div>
                </template>
            </ibox>
        </template>
        <template v-slot:footer>
            <BottomMenuMob v-if="$appUtils.isMobile()"
                           @onMenuClickItem="itemClick"
                           :items="menuItems"/>
            <div v-else class="container-fluid-grid">
                <div class="row">
                    <div class="col t-r">
                        <span class="btn-group btn-group-sm">
                            <a href="javascript:history.go(-1)"
                               v-if="!$appUtils.isMobile()"
                               class="btn btn-sm btn-secondary"
                            ><svg-icon icon="arrow-left"/> Voltar</a>
                            <button type="button"
                                    title="Abrir em outra página"
                                    class="btn btn-sm btn-info"
                                    @click="open"
                            ><svg-icon icon="external-link-alt"/> Abrir</button>
                            <button type="button"
                                    title="Imprimir"
                                    class="btn btn-sm btn-primary"
                                    @click="print"
                            ><svg-icon :class="{'refresh rotate-1-seg': downloading}" :icon="downloading ? 'sync' : 'print'"/> Imprimir</button>
                            <button type="button"
                                    title="Download"
                                    class="btn btn-sm btn-primary"
                                    :class="{'btn-dark': !$appUtils.isMobile()}"
                                    @click="downloadPdf()"
                            ><svg-icon :class="{'refresh rotate-1-seg': downloading}" :icon="downloading ? 'sync' : 'cloud-download-alt'"/> Download</button>
                        </span>
                    </div>
                </div>
            </div>
        </template>
    </DefaultTmpl>
</template>

<script>
    import DefaultTmpl from '@/templates/DefaultTmpl'
    import {createNamespacedHelpers} from 'vuex'
    import BottomMenuMob from "../components/particles/BottomMenuMob";
    const {mapGetters} =  createNamespacedHelpers('users');
    const pdfScript = 'pdfScript';

    export default {
        name: "PdfViewer",
        components:{DefaultTmpl, BottomMenuMob},
        computed: {
            ...mapGetters(['authToken']),
            title() {
                return this.$router.currentRoute.query.name || 'Visualização de PDF';
            },
            fileName() {
                return this.$router.currentRoute.query.name || 'Arquivo PDF.pdf';
            }
        },
        data() {
            return {
                loading: false,
                downloading: false,
                menuItems: [{
                    active: false,
                    icon: 'cloud-download-alt',
                    label: 'Baixar',
                    svgClass: null,
                    style: {
                        gridColumn: '5 / 5'
                    }
                }],
                blobFile: null
            }
        },
        methods: {
            downloadPdf() {
                if (this.downloading) return false;

                this.menuItems[0].icon = 'sync';
                this.menuItems[0].svgClass = 'refresh rotate-1-seg';

                this.downloading = true;
                const url = this.$router.currentRoute.query.url;
                const name = this.fileName;

                if (this.blobFile) {
                    const d = window.URL.createObjectURL(this.blobFile);
                    const link = document.createElement('a');
                    link.href = d;
                    link.download = name;
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();

                    setTimeout(() => {
                        this.downloading = false;
                        this.menuItems[0].svgClass = null;
                        this.menuItems[0].icon = 'cloud-download-alt';
                        document.body.removeChild(link);
                    }, 1000);

                } else {
                    this.$appUtils.downloadPdf(`${process.env.VUE_APP_API_BASE_URL}${url}`, name)
                        .catch(err => {
                            this.$snotify.error(this.$t('common.downloadPdfError'), this.$appStorage.getUser().name);
                            console.error(err);
                        })
                        .finally(() => setTimeout(() => {
                                this.downloading = false;
                                this.menuItems[0].svgClass = null;
                                this.menuItems[0].icon = 'cloud-download-alt';
                            },
                            1000)
                        );
                }
            },
            open() {
                const w = window.open(URL.createObjectURL(this.blobFile));
                if (w) {
                    w.focus();
                    return w;
                } else {
                    this.$snotify.warning('Seu navegador está bloqueando a abertura de novas janelas. Verifique a configuração.', this.$appStorage.getUser().name);
                }
            },
            print() {

                if (!this.$appUtils.isFirefox()) {
                    this.downloading = true;
                    const id = '__printIframe';
                    const ifrm = document.getElementById(id) || document.createElement('iframe');
                    ifrm.style.display = 'none';
                    ifrm.setAttribute('id', id);
                    ifrm.src = URL.createObjectURL(this.blobFile);

                    const outer = this;
                    ifrm.onload = function () {
                        ifrm.focus();
                        ifrm.contentWindow.print();
                        outer.downloading = false
                    };

                    document.body.appendChild(ifrm);
                } else {
                    const w = this.open();
                    if (w) w.print();
                }
            },
            itemClick() {
                this.downloadPdf();
            },
            async showPdf() {
                const url = this.$router.currentRoute.query.url;

                if (!url) {
                    this.$snotify.warning('URL do PDF inválida', this.$appStorage.getUser().name);
                    return false;
                }

                if (!pdfjsLib) {
                    this.$snotify.warning('Não consegui carregar a biblioteca para mostrar o PDF. Tente novamente e caso o problema persista, entre em contato com o suporte.', this.$appStorage.getUser().name);
                    return false;
                }

                const loadingTask = pdfjsLib.getDocument({
                    url: `${process.env.VUE_APP_API_BASE_URL}${url}`,
                    httpHeaders: { Authorization: `Bearer ${this.authToken}` },
                    withCredentials: false
                });

                const pdf = await loadingTask.promise;

                pdf.getData()
                    .then(data => {
                        this.blobFile = new Blob([data], {type: "application/pdf"});
                    })
                    .catch(err => {
                        this.blobFile = null;
                        console.error('Falha no load do PDF', err);
                    });


                for(let i = 0; i < pdf.numPages; i++) {

                    const page = await pdf.getPage(i + 1);
                    const scale = Math.floor(150 / 72.0);
                    const viewport = page.getViewport({scale});

                    const canvas = document.createElement('canvas');
                    canvas.className = 'pdf-canvas';
                    this.$refs.pdfContainer.appendChild(canvas);

                    const context = canvas.getContext("2d");
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    const renderContext = {
                        canvasContext: context,
                        viewport: viewport
                    };
                    await page.render(renderContext).promise;
                }

                this.loading = false;
            }
        },
        mounted() {

            this.loading = true;
            const element = document.getElementById(pdfScript);

            if (!!element) {
                this.showPdf();
            } else {
                const intersect = document.createElement('script');
                intersect.setAttribute('src', '/assets/javascript/pdf.js');
                intersect.setAttribute('id', pdfScript);
                intersect.setAttribute('defer', 'defer');
                intersect.setAttribute('async', 'true');

                intersect.onload = async () => {
                    this.showPdf()
                };
                document.head.appendChild(intersect);
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/css/variables";
    .loading-container {
        color: $theme_color_one;
        text-align: center;
        svg {
            width: 3em;
            height: 3em;
        }
    }
    .container-canvas {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 5px;
    }
    .pdf-canvas {
        width: 100%;
        max-width: 210mm;
        box-shadow: 2px 2px 2px 0 rgba(0,0,0, .5);
        border: 1px solid black;

        &:not(:first-child) {
            margin-top: 10px;
        }
    }
</style>
